<template>
  <div>
    <vs-button @click="active = !active">Edit</vs-button> {{ active }}
    <!-- <pre>{{data}}</pre> -->
    <editmap v-if="active" :data="data" />
    <viewmap v-else :data="data" />
  </div>
</template>

<script>
import VueResizable from "vue-resizable";
import viewmap from "./components/viewmap.vue";
import editmap from "./components/editmap.vue";
export default {
  name: "App",
  components: { VueResizable, viewmap, editmap },
  data() {
    const tW = 32;
    const tH = 0.5;
    return {
      active: false,
      datalog: null,
      ac: "hide",
      data: null,
      // handlers: ["r", "rb", "b", "lb", "l", "lt", "t", "rt"],
      left: `calc( 50% - ${tW / 2}px)`,
      top: `calc(50% - ${tH / 2}px)`,
      height: tH,
      width: tW,
      // maxW: 250,
      // maxH: 250,
      // minW: 75,
      // minH: 75,
      fit: true,
      event: "",
      ref: "",
      dragSelector: ".drag-container-1, .drag-container-2",
    };
  },
  methods: {
    eHandler(data) {
      console.log(data);
      this.datalog = data;
      this.width = data.width;
      this.height = data.height;
      this.left = data.left;
      this.top = data.top;
      this.event = data.eventName;
    },
    emove(ref) {
      this.ref = ref;
    },
  },
  mounted() {
    this.data = this.$session.get("data");
    console.log(this.$route.params.name);
  },
  filters: {
    checkEmpty(value) {
      return typeof value !== "number" ? 0 : value;
    },
  },
  computed: {
    destinationId() {
      return parseInt(this.$route.params.id);
    },
    destinationg() {
      console.log(this.$route.params.id);
      // location.reload();
      // return this.users.filter((post) => {
      //   return post.id.toString().toLowerCase().includes(this.$route.params.id);
      // });

      // return this.users.destinations.find(
      //   (getid) => getid.id === this.destinationId
      // );
    },
  },
};
</script>

<style scoped>
.block {
  /* height: 75px;
  width: 75px; */
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container2 {
  /* width: 2500px;
  height: 700px; */
  padding: 0;
  display: inline-block;
  border: 1px solid #dddddd;
  background: #ffffff;
  color: #333333;
  /* float: left; */
  margin: 10px;
}

#block1 {
  border: solid black 1px;
  height: 75px;
  width: 75px;
  display: inline-block;
  float: left;
}

.resizable {
  background-position: top left;
  width: 150px;
  height: 150px;
  padding: 0;
  border: 1px solid #003eff;
  background: #007fff;
  font-weight: normal;
  color: #ffffff;
  position: relative;
}

.table-block {
  display: table;
}

.table-row {
  display: table-row;
  text-align: center;
}

.table-cell {
  width: 50%;
  display: inline-block;
}

.table-input {
  width: 50px;
}

/* .drag-container-1,
.drag-container-2 {
  width: 100%;
  height: 20px;
  background: red;
  color: white;
  text-align: center;
  cursor: pointer;
} */

.table-container {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>